module.exports = __webpack_public_path__ + "img/menu-close.face26c5.svg";